<template>
  <div :class="classes">
    <label class="ms-Label">{{ label }}</label>

    <textarea
      v-if="multiline"
      :id="id"
      class="ms-TextField-field"
      :value="value"
      :disabled="disabled"
      @change="valueChanged"
      @input="valueChanged"
      @blur="$emit('blur', $event)"
      @keyup="$emit('keyup', $event)"
    ></textarea>
    <input
      v-else
      class="ms-TextField-field"
      :type="type"
      :value="value"
      :disabled="disabled"
      @change="valueChanged"
      @input="valueChanged"
      @blur="$emit('blur', $event)"
      @keyup="$emit('keyup', $event)"
    />
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    multiline: {
      type: Boolean,
      default: () => false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes() {
      const classes = ['ms-TextField '];
      if (this.multiline) {
        classes.push('ms-TextField--multiline');
      }
      if (this.disabled) {
        classes.push('is-disabled');
      }

      return classes;
    }
  },
  mounted() {
    new fabric['TextField'](this.$el, function() {});
  },
  methods: {
    valueChanged(e) {
      this.$emit('change', e.target.value);
      this.$emit('input', e.target.value);
    }
  }
};
</script>
